import Vue from 'vue'
import api from '../../../api/endpoints'

export default {
  fetchAdvisory ({commit, state}) {
    return Vue.http.get(api.GET_ADVISORY)
  },
  fetchQuoteExternalLink ({commit, state}) {
    return new Promise((resolve, reject) => {
      Vue.http.get(api.GET_QUOTE_EXTERNAL_LINK)
        .then(({data}) => {
          if (data && data.length > 0) {
            commit('SET_QUOTE_EXTERNAL_LINK', data[0])
          }
        })
        .catch((err) => {
          console.log(err)
          reject(err)
        })
    })
  },
  updateUserAdvisorySetting ({commit, state}, body) {
    return Vue.http.post(api.USER_SETTING('ADVISORY', body.maiUser), body)
  },
  clearAllUserAdvisorySetting ({commit, state}) {
    return Vue.http.delete(api.DELETE_USER_SETTINGS('ADVISORY'))
  }
}



// WEBPACK FOOTER //
// ./src/modules/library/store/actions.js